import {
  IBandUserBodyPreferences,
  IBandUserFlightPreferences,
  IBandUserHotelPreferences,
} from "Bands/types";
import { IPhoneNumber, IPlace, ISex } from "shared/types";
import { IUserName } from "./auth";

export enum UserRoles {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_USER = "ROLE_USER",
}

export interface IUserAttributes extends IUserName, IUserPatchAttributes {
  id: string;
  email: string;
  userRoles?: UserRoles;
  intercomToken?: string;
}

export interface IUser {
  id: string;
  username: string;
  attributes: IUserAttributes;
}

export interface IUserPatchData extends IUserPatchAttributes {
  email?: string;
  firstname?: string;
  lastname?: string;
}

export interface IUserPatchAttributes
  extends IBandUserBodyPreferences,
    IBandUserHotelPreferences,
    IBandUserFlightPreferences {
  sex?: ISex;
  birthDate?: string | null;
  birthCountry?: string;
  nationality?: string;
  addresses?: IUserAddress[];
  phoneNumbers?: IUserPhoneNumber[];
}

interface IUserAddress {
  data: {
    id: string;
    type: string;
    attributes: IPlace;
  };
}

interface IUserPhoneNumber {
  data: {
    id: string;
    type: string;
    attributes: IPhoneNumber;
  };
}
